import { render, staticRenderFns } from "./Internet.vue?vue&type=template&id=05237419&scoped=true&"
import script from "./Internet.vue?vue&type=script&lang=js&"
export * from "./Internet.vue?vue&type=script&lang=js&"
import style0 from "./Internet.vue?vue&type=style&index=0&id=05237419&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05237419",
  null
  
)

/* custom blocks */
import block0 from "./Internet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports